import styled from 'styled-components';

import { FONTS } from '../../../tokens/fonts';
import { BaseButton } from '../../buttons/baseButton';

export const TooltipWrapper = styled.div`
    display: ${props => props.show ? 'flex' : 'none'};
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background: rgba(255,255,255,1);
    border: 1px solid #ebebeb;
    box-shadow: 0 5px 10px rgba(0, 0, 0, .21);
    box-sizing: border-box;
    border-radius: 4px;
    padding: 25px 40px;
    position: absolute;
    top: 56px;
    left: 0;
    z-index: 5;
    width: 658px;
    @media (max-width: 690px) {
        flex-direction: column;
        align-items: flex-start;
        width: auto;
    }
`;

export const Content = styled.div`
    display: block;
`;

export const TooltipTitle = styled.div`
    ${FONTS.S};
    color: #979797;
    margin-bottom: 5px;
`;

export const TooltipCity = styled.div`
    ${FONTS.L};
    color: #000;
    @media (max-width: 690px) {
        margin-bottom: 20px;
    }
`;

export const TooltipFooter = styled.div`
    display: flex;
    flex-wrap: nowrap;
    @media (max-width: 690px) {
        justify-content: flex-start;
    }
    @media (max-width: 500px) {
        flex-direction: column;
        width: 100%;
    }
`;

export const Button = styled(BaseButton)`
    &:first-child {
        margin-right: 15px;
    }

    @media (max-width: 500px) {
        width: 100%;

        &:first-child {
            margin-right: 0;
            margin-bottom: 15px;
        }
    }
`;
